import type { CSSProperties } from 'react'
import { darkenHex, isValidHex } from '@/lib/colorUtils'

export const VIDEO_ACCENT_COLORS = {
  LIGHT: '#1d48af',
  DARK: '#2196f3',
} as const

export const VIDEO_ACCENT_HOVER_COLORS = {
  LIGHT: '#17398c',
  DARK: '#1976d2',
} as const

export const videoAccentStyle = (isDark: boolean): CSSProperties =>
  ({
    '--video-accent-color': isDark ? VIDEO_ACCENT_COLORS.DARK : VIDEO_ACCENT_COLORS.LIGHT,
    '--video-accent-hover-color': isDark ? VIDEO_ACCENT_HOVER_COLORS.DARK : VIDEO_ACCENT_HOVER_COLORS.LIGHT,
  }) as CSSProperties

/** ブランドカラーが設定されている場合だけ、動画枠・選択中サムネイル用の色を渡す。 */
export const videoFrameStyle = (brandColor: string | null | undefined): CSSProperties =>
  (typeof brandColor === 'string' && isValidHex(brandColor)
    ? ({
        '--video-frame-color': brandColor,
        '--video-brand-color': brandColor,
        '--video-brand-hover-color': darkenHex(brandColor),
      } as CSSProperties)
    : {})
